module.exports = __webpack_public_path__ + "media/images/entreprise-footer-3-b87371d68924d58904d7ec5bfbd07014.png";